// src/Components/Modals/ConfirmModal.js
import React from "react";

const ConfirmModal = ({
  show,
  onClose,
  onConfirm,
  title = "Are you sure?",
  message = "Please confirm your action.",
  confirmLabel = "Yes",
  cancelLabel = "No",
  variant = "warning",
  // Optional extra content between the message and the buttons, for confirmations that need a
  // choice rather than just yes/no. Callers that pass none render exactly as before.
  children = null
}) => {
  if (!show) return null;

  const variantClasses = {
    primary: "bg-primary",
    warning: "bg-warning",
    success: "bg-success",
    danger: "bg-danger"
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
      onClick={onClose}
    >
      {/*
        Deliberately NOT using the "modal"/"modal-dialog"/"modal-body" Bootstrap classes here -
        the theme's global stylesheet forces `.modal-body { height: 70vh; }` (style.css), meant
        for larger content modals elsewhere in the app. Reusing that class left this small
        confirm dialog with a huge empty area below the buttons regardless of its actual content.
        A plain flex-centered overlay + a naturally-sized card sidesteps that rule entirely.
      */}
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 12,
          backgroundColor: "#fff",
          boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center p-4">
          <div
            className={`rounded-circle d-inline-flex align-items-center justify-content-center mb-3 ${variantClasses[variant]}`}
            style={{ width: 56, height: 56 }}
          >
            <i className="far fa-clock fa-lg text-white"></i>
          </div>

          <h5 className="mb-2">{title}</h5>
          <p className={`text-muted ${children ? "mb-3" : "mb-4"}`} style={{ fontSize: 14 }}>{message}</p>

          {children && <div className="mb-4">{children}</div>}

          <div className="d-flex justify-content-center gap-2">
            <button
              className="btn btn-outline-secondary px-4"
              onClick={onClose}
            >
              {cancelLabel}
            </button>
            <button
              className="btn btn-outline-primary px-4"
              onClick={onConfirm}
            >
              <i className="fas fa-play-circle me-2"></i>
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
